<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Calendar from "primevue/calendar";

function toYmd(date) {
  if (!date) return "";
  const d = new Date(date);
  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0"),
  ].join("-");
}

function toDmy(date) {
  if (!date) return "–";
  const d = new Date(date);
  return [
    String(d.getDate()).padStart(2, "0"),
    String(d.getMonth() + 1).padStart(2, "0"),
    d.getFullYear(),
  ].join("/");
}

export default {
  components: {
    Layout,
    Calendar,
  },
  data() {
    const d = new Date();
    return {
      loading: false,

      filter: {
        date_start: new Date(d.getFullYear(), d.getMonth(), 1),
        date_end: new Date(d.getFullYear(), d.getMonth() + 1, 0),
        plan: "-1",
        order_by: "exclusaoindividual_personal",
        order_sort: "DESC",
      },

      plans: [],

      orderByOptions: [
        { value: "username",                  text: "Usuário" },
        { value: "name",                      text: "Nome" },
        { value: "plan",                      text: "Plano" },
        { value: "exclusaoindividual_personal",        text: "Envios Pessoal" },
        { value: "exclusaoindividual_team",            text: "Envios Equipe" },
        { value: "exclusaoindividual_total",           text: "Envios Total" },
        { value: "network_sponsoreds_active", text: "Indicados Ativos" },
        { value: "network_sponsoreds_total",  text: "Indicados Total" },
        { value: "network_team_active",       text: "Equipe Ativos" },
        { value: "network_team_total",        text: "Equipe Total" },
      ],

      orderSortOptions: [
        { value: "DESC", text: "Maior → Menor" },
        { value: "ASC",  text: "Menor → Maior" },
      ],

      fields: [
        { key: "username",                  label: "Usuário",          sortable: false },
        { key: "name",                      label: "Nome",             sortable: false },
        { key: "plan",                      label: "Plano",            sortable: false },
        { key: "exclusaoindividual_personal",        label: "Pessoal",          sortable: false, tdClass: "text-center", thClass: "text-center" },
        { key: "exclusaoindividual_team",            label: "Equipe",           sortable: false, tdClass: "text-center", thClass: "text-center" },
        { key: "exclusaoindividual_total",           label: "Total",            sortable: false, tdClass: "text-center", thClass: "text-center" },
        { key: "network_sponsoreds_active", label: "Indicados",        sortable: false, tdClass: "text-center", thClass: "text-center" },
        { key: "network_team_active",       label: "Equipe",           sortable: false, tdClass: "text-center", thClass: "text-center" },
      ],

      currentPage: 1,
      perPage: 25,

      list: null,
    };
  },
  computed: {
    totalRows() {
      return this.list ? this.list.length : 0;
    },
  },
  methods: {
    formatDate(date) {
      return toDmy(date);
    },
    getApproveds() {
      this.loading = true;
      this.list = null;

      const params = new URLSearchParams();
      if (this.filter.date_start) params.append("date_start", toYmd(this.filter.date_start));
      if (this.filter.date_end)   params.append("date_end",   toYmd(this.filter.date_end));
      if (this.filter.plan !== "-1") params.append("plan", this.filter.plan);
      params.append("order_by",   this.filter.order_by);
      params.append("order_sort", this.filter.order_sort);

      api
        .get("exclusaoindividual/approveds?" + params.toString())
        .then((response) => {
          if (response.data.status === "success") {
            this.plans = response.data.plans;
            this.list  = response.data.list;
            this.currentPage = 1;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getApproveds();
  },
  watch: {
    "filter.date_start": function () { this.getApproveds(); },
    "filter.date_end":   function () { this.getApproveds(); },
    "filter.plan":       function () { this.getApproveds(); },
    "filter.order_by":   function () { this.getApproveds(); },
    "filter.order_sort": function () { this.getApproveds(); },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Exclusão Individual</li>
      <li class="breadcrumb-item active">Aprovados</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Aprovados</h3>
        <p></p>
      </div>
    </div>

    <div id="dropdown" class="d-flex mb-4">
      <b-dropdown variant="outline-light" class="date-filter">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0 text-secondary">Data Início</h6>
              <div>{{ formatDate(filter.date_start) }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-group>
          <div @click.stop>
            <Calendar v-model="filter.date_start" dateFormat="dd/mm/yy" inline></Calendar>
          </div>
        </b-dropdown-group>
      </b-dropdown>

      <b-dropdown variant="outline-light" class="date-filter">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0 text-secondary">Data Fim</h6>
              <div>{{ formatDate(filter.date_end) }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-group>
          <div @click.stop>
            <Calendar v-model="filter.date_end" dateFormat="dd/mm/yy" inline></Calendar>
          </div>
        </b-dropdown-group>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0 text-secondary">Plano</h6>
              <div v-if="filter.plan == '-1'">Todos</div>
              <div v-else-if="plans.find(p => p.id == filter.plan)">{{ plans.find(p => p.id == filter.plan).name }}</div>
              <div v-else>–</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filter.plan" value="-1">Todos</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form v-for="p in plans" :key="p.id">
          <b-form-radio v-model="filter.plan" :value="p.id">{{ p.name }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0 text-secondary">Ordenar Por</h6>
              <div>{{ (orderByOptions.find(o => o.value === filter.order_by) || {}).text || '–' }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form v-for="opt in orderByOptions" :key="opt.value">
          <b-form-radio v-model="filter.order_by" :value="opt.value">{{ opt.text }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0 text-secondary">Ordenação</h6>
              <div>{{ filter.order_sort === 'DESC' ? 'Maior → Menor' : 'Menor → Maior' }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filter.order_sort" value="DESC">Maior → Menor</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form>
          <b-form-radio v-model="filter.order_sort" value="ASC">Menor → Maior</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>

      <div class="totals">
        <h6 class="m-0 text-secondary text-lowercase">Total</h6>
        <div>{{ totalRows }}</div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="min-vh-25 text-center d-flex justify-content-center align-items-center" v-if="loading">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>

        <div v-else-if="list && list.length === 0" class="min-vh-25 text-center d-flex justify-content-center align-items-center">
          <div>
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum registro encontrado
          </div>
        </div>

        <div v-else-if="list" class="table-responsive">
          <b-table
            :items="list"
            :fields="fields"
            class="table-nowrap table-style table-hover min-vh-25"
            head-variant="light"
            :current-page="currentPage"
            :per-page="perPage"
            responsive
          >
            <template #cell(network_sponsoreds_active)="data">
              {{ data.item.network_sponsoreds_active }} / {{ data.item.network_sponsoreds_total }}
            </template>
            <template #cell(network_team_active)="data">
              {{ data.item.network_team_active }} / {{ data.item.network_team_total }}
            </template>
          </b-table>

          <div class="d-flex justify-content-center mt-3" v-if="totalRows > perPage">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
::v-deep .dropdown-menu {
  min-width: 200px;
  white-space: nowrap;
}
</style>

<style>
.date-filter .dropdown-menu {
  padding: 0;
  min-width: 0;
  width: auto;
  white-space: normal;
  overflow: visible;
}

.date-filter .p-datepicker {
  border: none;
  box-shadow: none;
  width: auto !important;
}

.date-filter .p-datepicker table {
  font-size: 0.8rem;
}

.date-filter .p-datepicker table td {
  padding: 1px;
}

.date-filter .p-datepicker table td > span {
  width: 1.8rem;
  height: 1.8rem;
}

.date-filter .p-datepicker .p-datepicker-header {
  padding: 4px 8px;
}

.date-filter .p-datepicker .p-datepicker-header .p-datepicker-title {
  font-size: 0.85rem;
}

.date-filter .dropdown-menu .b-dropdown-group > ul {
  padding: 0;
}

.date-filter .dropdown-menu .b-dropdown-group > ul > li {
  list-style: none;
}
</style>
